import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCloud, FaShieldAlt, FaGlobe, FaDesktop, FaRobot, FaMobileAlt, FaBoxOpen, FaCogs, FaLaptopCode, FaServer, FaShieldVirus, FaDatabase, FaFileAlt, FaMoneyBillWave, FaClipboardCheck, FaCode, FaUserPlus, FaUsers, FaAdobe, FaPaintBrush, FaChalkboardTeacher, FaTv } from "react-icons/fa";
import "./Navbar.css";
const Navliks = ({ closeMobileMenu }) => {

  const getCategoryIcon = (category) => {
    switch (category) {
      case "AI & Generative AI":
        return <FaGlobe className="text-[grey] mr-4 text-3xl" />; // Brighter purple for AI
      case "Application Management":
        return <FaDesktop className="text-[grey] mr-4 text-3xl" />; // Brighter blue for apps
      case "Cloud":
        return <FaCloud className="text-[grey] mr-4 text-3xl" />; // Bright sky blue for cloud
      case "Security":
        return <FaShieldAlt className="text-[grey] mr-4 text-3xl" />; // Vibrant orange for security
      case "Software-as-a-Service":
        return <FaMobileAlt className="text-[grey] mr-4 text-3xl" />; // Vibrant green for SaaS
      case "Products":
        return <FaBoxOpen className="text-[grey] mr-4 text-3xl" />; // Bright red for products
      default:
        return null;
    }
  };

  // Enhanced item icons with larger size and vibrant themed colors
  const getItemIcon = (category, itemName) => {
    // Define color based on category for consistent theme with more vibrant colors
    let iconColor = "text-gray-600";

    if (category === "AI & Generative AI") iconColor = "text-indigo-600";
    if (category === "Application Management") iconColor = "text-blue-600";
    if (category === "Cloud") iconColor = "text-cyan-600";
    if (category === "Security") iconColor = "text-orange-600";
    if (category === "Software-as-a-Service") iconColor = "text-green-600";
    if (category === "Products") iconColor = "text-red-600";

    // AI & Generative AI items
    if (itemName.includes("Automation")) return <FaCogs className={`${iconColor} text-2xl`} />;
    if (itemName.includes("ChatBots")) return <FaRobot className={`${iconColor} text-2xl`} />;

    // Application Management items
    if (itemName.includes("Mobile App")) return <FaMobileAlt className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Application Development")) return <FaLaptopCode className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Application Management")) return <FaServer className={`${iconColor} text-2xl`} />;

    // Cloud items
    if (itemName.includes("Cloud Enablement")) return <FaCloud className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Cloud Management")) return <FaServer className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Infra-as-a-Service")) return <FaDatabase className={`${iconColor} text-2xl`} />;
    if (itemName.includes("SecDevOps")) return <FaShieldVirus className={`${iconColor} text-2xl`} />;

    // Security items
    if (itemName.includes("Application Security")) return <FaShieldAlt className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Unified End Point")) return <FaDesktop className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Web Application Firewall")) return <FaShieldVirus className={`${iconColor} text-2xl`} />;

    // Software as a Service items
    if (itemName.includes("Enterprise Asset")) return <FaDatabase className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Service Management")) return <FaFileAlt className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Financial ERP")) return <FaMoneyBillWave className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Inspection")) return <FaClipboardCheck className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Low-Code")) return <FaCode className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Customer/Vendor")) return <FaUserPlus className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Field Force")) return <FaUsers className={`${iconColor} text-2xl`} />;
    if (itemName.includes("IT Asset Management")) return <FaDesktop className={`${iconColor} text-2xl`} />;

    // Products items
    if (itemName.includes("Adobe")) return <FaUsers className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Corel")) return <FaPaintBrush className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Smart Classrooms")) return <FaChalkboardTeacher className={`${iconColor} text-2xl`} />;
    if (itemName.includes("Display Panels")) return <FaTv className={`${iconColor} text-2xl`} />;

    // Default icon if no match is found
    return <FaFileAlt className={`${iconColor} text-2xl`} />;
  };
  const links = [
    {
      name: "Portfolio",
      submenu: "true",
      sublinks: [
        {
          Head: "AI & Generative AI",
          sublink: [

            { name: "Intelligent Automation", path: "/services/AI&GenAI/Intelligent Automation" },
            { name: "AI ChatBots", path: "/services/AI&GenAI/AI ChatBots" },

          ],
        },
        {
          Head: "Software-as-a-Service",
          sublink: [
            // { name: "Enterprise Asset Management", path: "/services/Software-as-a-Service/Enterprise Asset Management" },
            { name: "Enterprise Asset Management", path: "/iassetmax" },
            { name: "Enterprise Service Management", path: "/services/Software-as-a-Service/Entrprise Service Management" },
            { name: "Financial ERP", path: "/services/Software-as-a-Service/Financial ERP" },
            { name: "Inspection Management", path: "/services/Software-as-a-Service/Inspection Management" },
            { name: "Low-Code/ No-Code Platform", path: "/services/Software-as-a-Service/Low-CodeNo-Code Platform" },
            { name: "Customer/Vendor Registration", path: "/services/Software-as-a-Service/CustomerVendor Registration" },
            { name: "Field Force Management", path: "/services/Software-as-a-Service/Field Force Management" },
            { name: "IT Asset Management", path: "/services/Software-as-a-Service/IT Asset Management" },

          ],
        },
        {
          Head: "Application Management",
          sublink: [
            { name: "Mobile App Development", path: "/" },
            { name: "Application Development", path: "/services/Application Management/Application Development" },
            { name: "Application Maintainance", path: "/services/Application Management/Application Maintainance" },
          ],
        },
        {
          Head: "Cloud",
          sublink: [
            { name: "Cloud Enablement of Applications", path: "/" },
            { name: "Cloud Management", path: "/services/Cloud/Cloud Management" },
            { name: "Infra-as-a-Service", path: "/services/Cloud/Infra-as-a-Service" },
            { name: "SecDevOps", path: "/services/Cloud/SecDevOps" },
          ],
        },
        {
          Head: "Security",
          sublink: [
            { name: "Application Security", path: "/services/Security/Application Security" },
            { name: "Unified End Point Management", path: "/services/Security/Unified End Point Management" },
            { name: "Web Application Firewall", path: "/services/Security/Web Application Firewall" },
          ],
        },

        {
          Head: "Products",
          sublink: [
            { name: "Adobe", path: "/services/Products/Adobe" },
            { name: "Corel", path: "/services/Products/Corel" },
            //  { name: "iAssetMax", path: "/iassetmax" },

            { name: "Display Panels ", path: "/" },
            { name: "Smart Classrooms", path: "/" },
          ],
        }
      ],
    },
    // {
    //   name: "Industries",
    //   submenu: "true",
    //   sublinks: [
    //     {
    //       Head: "Software as a Service",
    //       sublink: [
    //         { name: "Financial ERP", path: "/" },
    //         { name: "Enterprise Asset Management", path: "/" },
    //         { name: "Entrprise Service Management", path: "/" },
    //         { name: "IT Asset Management", path: "/" },
    //         { name: "Inspection Management", path: "/" },
    //         { name: "Field Force Management", path: "/" },
    //         { name: "Low-Code/No-Code Platform", path: "/" },
    //         { name: "Customer/Vendor Registration", path: "/" },
    //       ],
    //     },
    //     {
    //       Head: "Security",
    //       sublink: [
    //         { name: "Unified End Point Management", path: "/" },
    //         { name: "Application Security", path: "/" },
    //         { name: "Web Application Firewall", path: "/" },
    //       ], 
    //     },
    //     {
    //       Head: "Cloud",
    //       sublink: [
    //         { name: "Infra-as-a-Service", path: "/" },
    //         { name: "Cloud Management", path: "/" },
    //         { name: "Cloud Enablement of Applications", path: "/" },
    //         { name: "SecDevOps", path: "/" },


    //       ],
    //     },
    //     {
    //       Head: "AI&GenAI",
    //       sublink: [
    //         { name: "Intelligent Automation", path: "/" },
    //         { name: "AI ChatBots", path: "/" }, 
    //       ],
    //     },
    //     {
    //       Head: "Application Management",
    //       sublink: [
    //         { name: "Application Development", path: "/" },
    //         { name: "Application Management", path: "/" }, 
    //         { name: "Mobile App Development", path: "/" }, 
    //       ],
    //     },
    //     {
    //       Head: "Analytics",
    //       sublink: [
    //         { name: "API Development", path: "/" }, 
    //         { name: "ETL ", path: "/" },
    //         { name: "Analytics", path: "/" }, 

    //       ],
    //     },
    //     {
    //       Head: "Products",
    //       sublink: [
    //         { name: "Adobe", path: "/" }, 
    //         { name: "Corel ", path: "/" },
    //         { name: "Smart Classrooms", path: "/" }, 
    //         { name: "Display Panels", path: "/" }, 
    //         { name: "Financial Process Outsourcing", path: "/" }, 



    //       ],
    //     },
    //   ],
    // },
  ];
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [selectedMainCategory, setSelectedMainCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [isPortfolioClosed, setIsPortfolioClosed] = useState(false);

  // Function to handle main category click
  const handleMainCategoryClick = (navItem) => {
    if (selectedMainCategory !== navItem.name) {
      setSelectedMainCategory(navItem.name);
      setSelectedSubCategory(null);
    } else {
      setSelectedMainCategory(null);
      setSelectedSubCategory(null);
    }
  };

  // Function to handle subcategory click
  const handleSubCategoryClick = (subCategory) => {
    setSelectedSubCategory(subCategory);
  };


  return (
    <>
      {links.map((NavItem) => (
        <div
          key={NavItem.name}
          className="nav-item-container"
          onMouseLeave={() => setIsPortfolioClosed(false)}
        >
          <div className="px-5 py-5 text-left md:cursor-pointer group">
            {/* Increased height with py-5 and larger text */}
            <h1
              className=" py-5 flex justify-between items-center group text-[1.2rem]   "
              onClick={() => {
                heading !== NavItem.name
                  ? setHeading(NavItem.name)
                  : setHeading("");
                setSubHeading("");
                handleMainCategoryClick(NavItem);
              }}
            >
              {NavItem.name}
              <span className="text-lg md:hidden inline ">
                {heading === NavItem.name ? <IoIosArrowUp /> : <IoIosArrowDown />}
              </span>
              <span className="text-lg md:mt-1 md:ml-2 md:block hidden group-hover:rotate-180 group-hover:-mt-1 ">
                <IoIosArrowDown />
              </span>
            </h1>

            {/* Desktop Mega Menu with Left-Right Structure */}
            {NavItem.submenu && (
              <div>
                {/* <div className="Position zIndex absolute top-[6.5rem] rounded-lg hidden group-hover:md:block hover:md:block left-[35%] transform -translate-x-1/2 group-hover:duration-500 w-[80%] max-w-6xl shadow-xl"> */}
                <div
                  className={`Position zIndex absolute top-[6.5rem] rounded-lg
    ${isPortfolioClosed
                      ? "hidden"
                      : "hidden group-hover:md:block hover:md:block"
                    }
    left-[35%] transform -translate-x-1/2
    group-hover:duration-500 w-[80%] max-w-6xl shadow-xl`}
                >
                  <div className="bg-white rounded-lg p-8 flex bg-gradient-to-b from-white to-gray-50">
                    {/* Left side: Category Headings */}
                    <div className="w-1/4 border-r pr-6">
                      {NavItem.sublinks.map((SubNavItem, index) => (
                        <div
                          key={index}
                          onClick={() => handleSubCategoryClick(SubNavItem.Head)}
                          className={`py-4 px-5 cursor-pointer rounded-md mb-4 transition-all duration-300 ${selectedSubCategory === SubNavItem.Head
                              ? "bg-gray-100 border-l-4 border-[#002C78] shadow-md"
                              : "hover:bg-gray-50 hover:border-l-4 hover:border-[#002C78]/50 hover:shadow-sm"
                            }`}
                        >
                          <h1 className="text-[0.9rem] font-bold flex items-center">
                            {getCategoryIcon(SubNavItem.Head)}
                            {SubNavItem.Head}
                          </h1>
                        </div>
                      ))}
                    </div>

                    {/* Right side: Subcategory Links */}
                    <div className="w-3/4 pl-8">
                      {NavItem.sublinks.map((SubNavItem) => (
                        selectedSubCategory === SubNavItem.Head || (!selectedSubCategory && NavItem.sublinks.indexOf(SubNavItem) === 0) ? (
                          <div key={SubNavItem.Head}>
                            <h1 className="text-[1.5rem] font-bold pb-[1rem] border-b mb-6 flex items-center">
                              {getCategoryIcon(SubNavItem.Head)}
                              {SubNavItem.Head}
                            </h1>
                            <ul className="grid grid-cols-3 gap-4">
                              {SubNavItem.sublink.map((slink, index) => (
                                <li key={index} className="text-[0.9rem] text-gray-700 my-3 hover:text-[#F23100] transition-all duration-200 transform hover:translate-x-1 flex items-center gap-4">
                                  {getItemIcon(SubNavItem.Head, slink.name)}
                                  <Link to={slink.path} className="font-medium hover:underline" onClick={() => {
                                    setIsPortfolioClosed(true);
                                    setHeading("");
                                    setSubHeading("");
                                    setSelectedMainCategory(null);
                                    setSelectedSubCategory(null);
                                    closeMobileMenu?.();
                                  }}>{slink.name}</Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ) : null
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Mobile Dropdown - Enhanced */}
          <div className={`${heading === NavItem.name ? "md:hidden" : "hidden"}`}>
            {/* Sublinks */}
            {NavItem.sublinks &&
              NavItem.sublinks.map((mlinks, index) => (
                <div key={index}>
                  <div className="overflow-y-auto">
                    <h1
                      onClick={() =>
                        subHeading !== mlinks.Head
                          ? setSubHeading(mlinks.Head)
                          : setSubHeading("")
                      }
                      className="py-4 pl-10 font-bold md:pr-0 pr-4 text-[1.3rem] flex justify-between items-center"
                    >
                      <span className="flex items-center">
                        {getCategoryIcon(mlinks.Head)}
                        {mlinks.Head}
                      </span>
                      <span className="text-lg md:mt-1 md:ml-2 inline">
                        {subHeading === mlinks.Head ? <IoIosArrowUp /> : <IoIosArrowDown />}
                      </span>
                    </h1>
                    <div className={`${subHeading === mlinks.Head ? "md:hidden" : "hidden"}`}>
                      {mlinks.sublink.map((mlink, idx) => (
                        <li key={idx} className="py-3 pl-20 flex items-center gap-4">
                          {getItemIcon(mlinks.Head, mlink.name)}
                          <Link
                            to={mlink.path}
                            className="text-[1.1rem] hover:text-blue-500 font-medium"
                            onClick={closeMobileMenu}
                          >
                            {mlink.name}
                          </Link>
                        </li>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default Navliks;
